import { render, staticRenderFns } from "./PanelTextInput.vue?vue&type=template&id=01011088&lang=pug"
import script from "./PanelTextInput.vue?vue&type=script&lang=js"
export * from "./PanelTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports